const message = {
  msg_1: 'Technical Parameters',
  msg_2: 'Technical Parameters',
}

export default message